import cn from 'classnames'
import { type ReactElement } from 'react'
import { useSnapshot } from 'valtio'
import { CONTACT_US_URL, STANDARD_PAY_CONTACT_US_URL } from '../../../utils/commonUrls'
import QuestionIcon from '../../ui/icons/QuestionIcon'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'
import { GlobalSiteDomainEnum } from '../../../types/GlobalSiteDomainEnum'

interface SupportButtonProps {
  expanded: boolean
}

export function SupportButton ({ expanded }: SupportButtonProps): ReactElement {
  const { siteDomainEnum } = useSnapshot(proxyGlobalAuth)

  return (
    <a
      className={
        cn(
          'hover:opacity-90 active:opacity-95 rounded-lg bg-white py-2 mb-10 flex flex-row',
          expanded ? 'px-6' : 'px-2'
        )
      }
      href={siteDomainEnum === GlobalSiteDomainEnum.WastePay ? CONTACT_US_URL : STANDARD_PAY_CONTACT_US_URL}
      target="_blank"
      rel="noreferrer noopener"
    >
      <div className="w-6 h-6 ">
        <QuestionIcon />
      </div>
      {expanded && (
        <span className="ml-1 text-sm flex self-center font-medium">
          Contact Support
        </span>
      )}
    </a>
  )
}
